import { render } from "./JobsList.vue?vue&type=template&id=536a1729&scoped=true&lang=true"
import script from "./JobsList.vue?vue&type=script&lang=js"
export * from "./JobsList.vue?vue&type=script&lang=js"

import "./JobsList.vue?vue&type=style&index=0&id=536a1729&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-536a1729"]])

export default __exports__